var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fanzonePage"},[(_vm.state)?_c('Faq',{attrs:{"cate":_vm.cate}}):_vm._e(),_vm._m(0)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"indexBox waitingSeason",staticStyle:{"margin-top":"30px"}},[_c('div',{staticClass:"container"},[_c('img',{attrs:{"src":require("@/assets/img/bg_waitingSeason.png"),"alt":"준비중입니다"}})])])
}]

export { render, staticRenderFns }